import DangerBox from 'components/Web_User_Interface/720p_Series/PTZ_Control/DangerBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  DangerBox,
  BreadCrumbs,
  SEOHelmet,
  React
};